var _path, _path2, _g, _g2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsColumna1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 532,
    viewBox: "0 0 343 532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.045 80.1099H229.174C226.409 80.1099 224.389 75.2808 225.11 70.4516L231.747 26.3857C233.214 16.7758 238.072 10.0874 243.627 10.0874H319.617C325.148 10.0874 330.029 16.7758 331.472 26.3857L338.109 70.4516C338.831 75.2808 336.811 80.1099 334.045 80.1099Z",
    fill: "#FE6571"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5831 0C76.3169 0 86.6111 4.28141 94.2011 11.9024C101.791 19.5233 106.055 29.8595 106.055 40.6372V81.2744H25.1111V40.6372C25.1111 29.8595 29.3751 19.5233 36.965 11.9024C44.555 4.28141 54.8492 0 65.5831 0Z",
    fill: "#3098F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3923 307.573H59.6659C26.7669 307.573 0.194669 280.045 0.194669 246.04L0 179.026H131.645L131.839 246.04C131.839 280.045 105.218 307.573 72.3923 307.573Z",
    fill: "#F2EAE2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.989 301.342C313.588 301.342 340.014 274.808 340.014 242.076C340.014 209.343 313.588 182.809 280.989 182.809C248.39 182.809 221.963 209.343 221.963 242.076C221.963 274.808 248.39 301.342 280.989 301.342Z",
    fill: "#FFCC00"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3826 498.92C25.7663 485.251 23.5906 469.84 26.1624 454.863C28.7342 439.885 35.9236 426.096 46.7169 415.44C57.5101 404.784 71.3625 397.799 86.3204 395.47C101.278 393.141 116.587 395.585 130.088 402.458L110.898 440.536C103.85 436.963 95.6777 436.347 88.1779 438.824C80.6781 441.301 74.4655 446.668 70.9067 453.744C67.3479 460.82 66.7344 469.026 69.2013 476.556C71.6681 484.087 77.0132 490.325 84.0607 493.898L64.8227 532C50.6598 524.884 39.2499 513.249 32.3826 498.92Z",
    fill: "#3098F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338.415 483.779H224.526C223.824 483.778 223.131 483.615 222.503 483.302C221.874 482.988 221.325 482.534 220.9 481.973C220.474 481.413 220.183 480.762 220.048 480.07C219.914 479.378 219.94 478.664 220.125 477.984L227.339 451.159C228.101 448.317 229.774 445.808 232.1 444.018C234.426 442.228 237.274 441.259 240.205 441.259H322.736C325.669 441.257 328.521 442.226 330.851 444.016C333.181 445.805 334.859 448.315 335.625 451.159L342.839 477.984C343.025 478.666 343.05 479.382 342.915 480.076C342.779 480.769 342.486 481.422 342.057 481.983C341.629 482.544 341.077 482.998 340.446 483.31C339.814 483.621 339.119 483.782 338.415 483.779Z",
    fill: "#F2EAE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.839,
    height: 128.595,
    fill: "white",
    transform: "translate(0 179.026)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.028,
    height: 118.509,
    fill: "white",
    transform: "translate(221.963 182.809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColumna1);
export default __webpack_public_path__ + "static/media/icons-columna1.00c3a2dba17cca3d6bc998d62b2e0a4c.svg";
export { ForwardRef as ReactComponent };